const DEFAULT_INITIAL_MOUNTED_CONTENT_ACCORDION = true;
const DEFAULT_UNMOUNTED_CONTENT_ACCORDION = false;
const DEFAULT_INACTIVE_BACKGROUND_CHEVRON = '#fff0e4';
const DEFAULT_EXPANDED_CONTENT_ACCORDION = false;
const DEFAULT_ACTIVE_BACKGROUND_CHEVRON = '#e5f6ff';
const DEFAULT_DISABLED_HEAD_ACCORDION = false;
const DEFAULT_PROGRESS_LOADING_API = false;
const DEFAULT_SIZE_TINT_CHEVRON = 16; // height x width
const DEFAULT_VISIBLE_CHEVRON = true;
const DEFAULT_CONTENT_HEIGHT = 100;
const DEFAULT_HEIGHT_CONTENT = 0; //optimize method
const DEFAULT_TINT_CHEVRON = '#16182b';

export {
  DEFAULT_INITIAL_MOUNTED_CONTENT_ACCORDION,
  DEFAULT_UNMOUNTED_CONTENT_ACCORDION,
  DEFAULT_INACTIVE_BACKGROUND_CHEVRON,
  DEFAULT_EXPANDED_CONTENT_ACCORDION,
  DEFAULT_ACTIVE_BACKGROUND_CHEVRON,
  DEFAULT_DISABLED_HEAD_ACCORDION,
  DEFAULT_PROGRESS_LOADING_API,
  DEFAULT_SIZE_TINT_CHEVRON,
  DEFAULT_VISIBLE_CHEVRON,
  DEFAULT_CONTENT_HEIGHT,
  DEFAULT_HEIGHT_CONTENT,
  DEFAULT_TINT_CHEVRON,
};
